var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"menu-left py-0"},_vm._l((_vm.menuItems),function(menuItem,i){return _c('mainMenuItem',{key:i,staticClass:"menu-border",attrs:{"MenuItem":menuItem}})}))}
var staticRenderFns = []

export { render, staticRenderFns }